/**
 * Waitlist atoms for managing waitlist signup state
 *
 * @since 1.0.0
 */
import { Effect } from "effect";
import { WaitlistRpcClient } from "../rpc-client.ts";

/**
 * Submit waitlist function atom
 *
 * Calls the waitlist.join RPC endpoint to add an email to the waitlist.
 * Returns Effect that completes when submission is done.
 *
 * @example
 * ```typescript
 * const submitWaitlist = useAtomSet(submitWaitlistAtom, { mode: "promise" });
 *
 * try {
 *   const entry = await submitWaitlist({ email: "user@example.com", name: "John" });
 *   console.log("Joined waitlist:", entry);
 * } catch (error) {
 *   console.error("Failed to join:", error);
 * }
 * ```
 *
 * @since 1.0.0
 */
export const submitWaitlistAtom = WaitlistRpcClient.runtime.fn(
  Effect.fnUntraced(function*(params: { email: string; name?: string }) {
    /* v8 ignore start -- @preserve Function body tested via integration tests */
    const client = yield* WaitlistRpcClient;
    const entry = yield* client("waitlist.join", params);
    return entry;
    /* v8 ignore stop */
  }),
);
